/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Form_Choose_Groups_DescriptionInputs */

const en_users_form_choose_groups_description = /** @type {(inputs: Users_Form_Choose_Groups_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select one or more groups that define this user's permissions and profile options.`)
};

const pt_br2_users_form_choose_groups_description = /** @type {(inputs: Users_Form_Choose_Groups_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione um ou mais grupos que definem as permissões e opções de perfil deste usuário.`)
};

/**
* | output |
* | --- |
* | "Select one or more groups that define this user's permissions and profile options." |
*
* @param {Users_Form_Choose_Groups_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_form_choose_groups_description = /** @type {((inputs?: Users_Form_Choose_Groups_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Form_Choose_Groups_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_form_choose_groups_description(inputs)
	return pt_br2_users_form_choose_groups_description(inputs)
});